import React, { Component } from 'react';
import IconeSubscrito from './IconeSubscrito';

interface IPropsIconePeticaoSubscrito {
}


export default class IconePeticaoSubscrito extends React.Component<IPropsIconePeticaoSubscrito> {


    render() {
        return (
            <IconeSubscrito fill='red'>
                <path d="M 9.00,16.00
                    C 9.00,16.00 19.99,16.00 19.99,16.00
                    19.99,16.00 20.00,4.00 20.00,4.00
                    20.00,4.00 9.00,4.00 9.00,4.00
                    9.00,4.00 9.00,2.02 9.00,2.01
                    9.00,2.01 21.99,2.02 21.99,2.02
                    21.99,2.02 21.99,18.00 21.99,18.00
                    22.00,18.01 7.00,18.00 7.00,18.00
                    7.00,18.00 6.98,2.00 6.98,2.00
                    6.98,2.00 9.00,2.01 8.99,2.01
                    9.01,2.00 9.00,16.00 9.00,16.00 Z" />
                <path d="M 2.00,4.00
                    C 2.00,4.00 3.99,4.00 3.99,4.00
                    3.99,4.00 4.01,19.99 4.01,19.99
                    4.01,19.99 20.05,20.00 20.05,20.00
                    20.05,20.00 20.04,21.99 20.04,21.99
                    20.04,21.99 1.97,22.02 1.97,22.02
                    1.97,22.02 2.00,4.00 2.00,4.00 Z" />
            </IconeSubscrito>
        );
    }
}
